import React, {useState} from 'react';

export const FormularioCuidadores = ({setPantallaPerfil, DataForm}) => {
	const {nombre, id} = DataForm;

	const [CV, setCV] = useState('');

	const [Usuario, setUsuario] = useState({
		nombre: '',
		apellidos: '',
		nombreUsuario: '',
		correo: '',
		contraseña: '',
		direccion: '',
		telefono1: '',
		telefono2: '',
		ratio: '',
		referenciasExternas: '',
		lugarNacimiento: '',
		desplazamiento: '',
	});

	const handleInpuntChange = (event) => {
		setUsuario({
			...Usuario,
			[event.target.name]: event.target.value,
		});
	};

	const [SelectOption1, setSelectOption1] = useState('No');

	const handleOptionChangeRadio1 = (event) => {
		setSelectOption1(event.target.value);
		handleInpuntChange(event);
	};

	const guardarCambios = () => {
		console.log('Guradar cambios Usuario');
		setPantallaPerfil(false);
	};

	const borrarCuenta = () => {
		console.log('borrar Usuario');
		setPantallaPerfil(false);
	};

	return (
		<>
			<div className='formularioUsuario'>
				<div
					className='buttonAtrasFormularioUsuario'
					onClick={() => setPantallaPerfil(false)}
				>
					Atrás
				</div>
				<div className='contentFormularioUsuario'>
					<div className='fotoUser'>
						<div className='centrador'>
							<img src='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.f_8EvyyRdsiVsNOsNXJHjQHaE7%26pid%3DApi&f=1&ipt=35fc4f4f445eb43cee3885bfc5597895cc6b82f16d4e39cd8899175666cbcffa&ipo=images' />
						</div>
						<div className='centrador nombreID'>
							<div className='centrador nombreUsuarioForm'>{nombre}</div>
							{/*<div className='IDUsuario'><b>ID : </b>{id}</div>*/}
						</div>
					</div>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>Nombre</div>
						<div>
							<input
								type='text'
								className='inputTextUsuario'
								value={Usuario.nombre}
								name={'nombre'}
								onChange={handleInpuntChange}
							/>
						</div>
					</div>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>Apellidos</div>
						<div>
							<input
								type='text'
								className='inputTextUsuario'
								value={Usuario.apellidos}
								name={'apellidos'}
								onChange={handleInpuntChange}
							/>
						</div>
					</div>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>Nombre de usuario</div>
						<div>
							<input
								type='text'
								className='inputTextUsuario'
								value={Usuario.nombreUsuario}
								name={'nombreUsuario'}
								onChange={handleInpuntChange}
							/>
						</div>
					</div>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>Correo</div>
						<div>
							<input
								type='text'
								className='inputTextUsuario'
								value={Usuario.correo}
								name={'correo'}
								onChange={handleInpuntChange}
							/>
						</div>
					</div>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>Contraseña</div>
						<div>
							<input
								type='text'
								className='inputTextUsuario'
								value={Usuario.contraseña}
								name={'contraseña'}
								onChange={handleInpuntChange}
							/>
						</div>
					</div>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>Dirección</div>
						<div>
							<input
								type='text'
								className='inputTextUsuario'
								value={Usuario.direccion}
								name={'direccion'}
								onChange={handleInpuntChange}
							/>
						</div>
					</div>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>Teléfono 1</div>
						<div>
							<input
								type='text'
								className='inputTextUsuario'
								value={Usuario.telefono1}
								name={'telefono1'}
								onChange={handleInpuntChange}
							/>
						</div>
					</div>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>Teléfono 2</div>
						<div>
							<input
								type='text'
								className='inputTextUsuario'
								value={Usuario.telefono2}
								name={'telefono2'}
								onChange={handleInpuntChange}
							/>
						</div>
					</div>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>Ratio</div>
						<div>
							<input
								type='text'
								className='inputTextUsuario'
								value={Usuario.ratio}
								name={'ratio'}
								onChange={handleInpuntChange}
							/>
						</div>
					</div>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>Referencias Externas</div>
						<div>
							<input
								type='text'
								className='inputTextUsuario'
								value={Usuario.referenciasExternas}
								name={'referenciasExternas'}
								onChange={handleInpuntChange}
							/>
						</div>
					</div>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>Lugar de nacimiento</div>
						<div>
							<input
								type='text'
								className='inputTextUsuario'
								value={Usuario.lugarNacimiento}
								name={'lugarNacimiento'}
								onChange={handleInpuntChange}
							/>
						</div>
					</div>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>Desplazamiento</div>
						<div className='buttonRadioFormUsu'>
							<div className='contentButtonRadioFormUsu'>
								<div>Si</div>
								<input
									type='radio'
									value={'Si'}
									name={'desplazamiento'}
									checked={SelectOption1 === 'Si'}
									onChange={handleOptionChangeRadio1}
								/>
							</div>
							<div className='contentButtonRadioFormUsu'>
								<div>No</div>
								<input
									type='radio'
									value={'No'}
									name={'desplazamiento'}
									checked={SelectOption1 === 'No'}
									onChange={handleOptionChangeRadio1}
								/>
							</div>
						</div>
					</div>
					<div className='datoFormularioUsuario'>
						<div className='labelDatoFormUsu'>Curriculum Vitae</div>
						<div>
							<input
								className='inputTextUsuario'
								type='file'
								onChange={(e) => setCV(e.target.files[0])}
							/>
						</div>
					</div>
				</div>
				<div className='buttonGuardar'>
					<div
						className='button'
						Id='buttonGuardarFormUsu'
						onClick={guardarCambios}
					>
						<b>Guardar cambios</b>
					</div>
					<div
						className='button borrarCuenta'
						Id='button buttonBorrarFormUsu'
						onClick={borrarCuenta}
					>
						<b>Borrar Usuario</b>
					</div>
				</div>
			</div>
		</>
	);
};
